import * as React from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { Tooltip as MuiTooltip } from '@mui/material'

import InfoIcon from '@mui/icons-material/Info'

import { theme } from '../../themes/theme'

const StyledTooltip = styled(MuiTooltip)`
  color: ${theme.colors.primary};

  :hover {
    cursor: pointer;
  }

  &.MuiSvgIcon-root {
    font-size: 22px;
  }

  svg {
    height: 22px;
    width: 22px;
  }
`

function Tooltip({ info }) {
  return (
    <StyledTooltip title={info} placement="right" arrow aria-label="Info">
      <InfoIcon />
    </StyledTooltip>
  )
}

Tooltip.propTypes = {
  info: PropTypes.string.isRequired
}

export default Tooltip
